export const AdminRoutes = new Set([
  "/emailchannellist",
  "/emailconfig",
  "/verifysupportaddress",
  "/verifyworktualsupportaddress",
  "/addsupportaddressemail",
  "/addworktualsupportaddress",
  "/usermanagement",
  "/usermanagement/edit",
  "/skillmanagement",
  "/callflowview",
  "/callflow",
  "/callconfig",
  "/callconfig/create",
  "/callconfig/edit",
  "/contactcenternumber",
  "/answeredcallreport",
  "/missedcallreport",
  "/outboundcallreport",
  "/interactionreport",
  "/routingprofile/create",
  "/routingprofile/edit",
  "/customqueue/list",
  "/customqueue",
  "/customqueue/edit",
  "/routingprofile",
  "/smslisttable",
  "/playprompt",
  "/businesshours/list",
  "/businesshours/create",
  "/conversation/webchat",
  "/businesshours/edit",
  "/businesshours/view",
  "/webchatwidget/configuration",
  "/webchatwidgetedit/configuration",
  "/webchatwidget/list",
  "/dispositionstatus",
  "/dispositiondetails",
  "/agentstatus",
  "/agentdetails/create",
  "/agentstatus/agentdetails/edit",
  "/agentstatus/agentdetails/view",
  "/agentdetails",
  "/customertag",
  "customertype",
  "/supervisorviewcontact",
  "/supervisorprofilecontact",
  "/supervisor/blockcontact",
  "/supervisor/dndcontact",
  "/supervisor/createcontact",
  "/blockedcontactslist",
  "/dndcontactlist",
  "/blockrequestdetails",
  "/dndrequestdetails",
  "/blockrequestdetails",
  "/dndrequestdetails",
  "/supervisorprofilecontact/display",
  "/contactactivity",
  "/conversation/allactivity",
  "/analytics",
  "/cochat",
  "/shortcutkeys",
  "/addsupport",
  "/suspendedemails",
  "/chatsreport",
  "/webchatinteractionreport",
  "/webchatagentchatreport",
  "/webchat-acw-chat-report",
  "/webchat-queue-chat-report",
  "/dashboard",
  "/icons",
  "/chatbot",
  "/chatflow",
  "/chatflowlist",
  "/createBot",
  "/dashboardreport",
  "/websiteurl",
  "/nodatareport",
  "/connectors",
  "/connectorsinner",
  "/contactconnector",
  "/contactform",
  "/apiintegration",
  "/apiconfiguration",
  "/apicontactsync",
  "/createapi",
  "/apiinner",
  "/oauthclient",
  "/addclient",
  "/editclient",
  "/endpointdetails",
  "/connectorsuccess",
  "/submodule",
  "/channelconfiguration",

  "/facebookconfig",
  "/updatefacebook",
  "/addfacebookacc",
  "/instagramconfig",
  "/addinstagramacc",
  "/updateinstagram",
  "/whatsappconfig",
  "/updatewhatsapp",
  "/channelreports",
  "/agentreports",
  "/aibotreports",
  "/smsupdate",
  "/AllActivity",
  "/allactivity",
  "/knowledgebase",
  "/knowledgebasemain",
  "/knowledgebaseinner",
  "/settingspage",
  "/chatscreenagent",
  "/contactscreen",
  "/flowscreen",
  "/dummy",
  "/standaloneDashboard",
  "/reportsmain",
  "/leadgenaration",
  "/conversationaltriggers",
  "/customersatisfaction",
  "/customersatisfaction/create",
  "/contactscreen",
  "/manageduplicate",
  "/contactsdetail",
  "/connectorslist",
  "/connectorscompanylist",
  "/shopifyconnection",
  "/shopifystorecheck",
  "/bigcommerceconnection",
  "/bigcommerceload",
  "/connectionlist",
  "/paymentmethods",
  "/paymentmethods/paypal",
  "/paymentmethods/stripe",
  "/paymentmethods/globalpayment",
  "/customerscreen",
  "/customerwaiting",
  "/paymentmethods/square",
  "/paymentmethods/razorpay",
  "/chatbotonboarding",
  "/contactsettings",
  "/magentolist",
  "/magentonewconnection",
  "/googleSheetConnection",
  "/allactivity",
  "/chatscreenagent",
  "/chatlimit",
  "/emailtemplate",
  "/pdfviewer",
  "/restrictedrestricted",
  "/restrictedcontacts",
  "/hubspotconnectorlist",
  "/hubspotconnection",
  "/editorone",
  "/agentanalyticsmain",
  "/bigcommerceconnectionlist",
  "/woocommercelist",
  "/woocommercenewconnection",
  "/privateappcreate",
  "/wixconnection",
  "/wixstorecheck",
  "/wixapiconnection",
  "/wixconnectionlist",
  "/internalchat",
  "/aibotanalytics",
  "/visitorinsights",
  "/sheduledreports",
  "/queueanalytics",
  "/customreports",
  "/createcustomreports",
  "/recordings",
  "/audiorecordings",
  "/recordingscreen",
  "/customreports/createcustomreports",
  "/dynamicdashboard"
]);

export const SupervisorRoutes = new Set([
  "/allactivity",
  "/chatscreenagent",
  "/shortcutkeys",
  "/chatsreport",
  "/blockedcontactslist",
  "/dndcontactlist",
  "/webchatinteractionreport",
  "/webchatagentchatreport",
  "/webchat-acw-chat-report",
  "/webchat-queue-chat-report",
  "/answeredcallreport",
  "/missedcallreport",
  "/outboundcallreport",
  "/interactionreport",
  "/analytics",
  "/cochat",
  "/supervisorviewcontact",
  "/supervisorprofilecontact",
  "/supervisor/blockcontact",
  "/supervisor/dndcontact",
  "/supervisor/createcontact",
  "/supervisorprofilecontact/display",
  "/icons",
  // "/createBot",
  // "/admindashboard",
  "/dashboard",
  "/dashboardreport",
  "/nodatareport",
  "/channelreports",
  "/agentreports",
  "/aibotreports",
  "/settingspage",


  "/flowscreen",
  "/standaloneDashboard",
  "/reportsmain",

  "/contactscreen",
  "/contactform",
  "/manageduplicate",
  "/contactsdetail",
  "/restrictedcontacts",
  "/restrictedrestricted",
  "/dispositionstatus",
  "/agentstatus",
  "/customertag",
  "/customertype",
  "/connectors",
  "/apiconfiguration",
  "/businesshours/list",
  "/usermanagement",
  "/chatlimit",
  "/webchatwidget/list",
  "/BusinessHours/view",
  "/businesshours/edit",
  "/usermanagement/edit",
  "/callconfig",
  "/webchatwidgetedit/configuration",
  "/leadgenaration",
  "/emailconfig",
  "/addworktualsupportaddress",
  "/smslisttable",
  "/smsupdate",
  "/whatsappconfig",
  "/updatewhatsapp",
  "/facebookconfig",
  "/instagramconfig",
  "/apiintegration",
  "/createapi",
  "/oauthclient",
  "/addclient",
  "/agentdetails/create",
  "/customqueue/list",
  "/customqueue",
  "/contactcenternumber",
  "/playprompt",
  "/editorone",
  "/skillmanagement",
  "/routingprofile",
  "/routingprofile/create",
  "/routingprofile/edit",
  "/internalchat",
  "/aibotanalytics",
  "/visitorinsights",
  "/sheduledreports",
  "/queueanalytics",
  "/customreports",
  "/createcustomreports",
  "/recordings",
  "/audiorecordings",
  "/recordingscreen",
  "/customreports/createcustomreports",
  "dynamicdashboard"
]);

export const AgentRoutes = new Set([
  "/myactivity",
  "/chatscreenagent",
  "/supervisor/createcontact",
  "/supervisorviewcontact",
  "/supervisorprofilecontact/display",
  "/cochat",
  "/shortcutkeys",
  "/agentdashboard",
  "/icons",
  "/agentdashboardreport",
  "/standaloneDashboard",
  "/agentdashboardstandalone",
  "/contactscreen",
  "/contactsdetail",
  "/editorone",
  "/internalchat",
  "/recordings",
  "/audiorecordings",
  "/recordingscreen",
  '/dashboardreport',
  "dynamicdashboard"
]);

export const PublicRoutes = new Set(["/login", "/", "/resetpassword", "/icons", "/notfound", "/settings", "/whatsappwebview", "/whatsapppaymentwebview", '/whatsappwebcallback', '/facebookwebcallback', '/instagramwebcallback', '/wix3ds','/unsubscribe','/customersatisfaction/feedbackForm','/customersatisfaction/feedbackForms']);
